window.app = window.app || {};

/**
 * Load the contents of the given URL in the page foldout section
 * @param {String} url
 */
window.app.loadFoldout = function(url) {
    const $foldout = $('.js-foldout').addClass('loading');
    let xhr        = $foldout.data('xhr');
    if (xhr) {
        xhr.abort();
    }

    xhr = $.ajax({
        url: url
    }).done(function(data) {
        $foldout.html(data).show().removeClass('loading');
        window.app.loadComponentsFor($foldout);
    }).fail((xhr) => {
        if (xhr.statusText === 'abort') {
            return;
        }
        // Silently ignore failures
        $foldout.hide();
    });
    $foldout.data('xhr', xhr);
};

export default ($container) => {
    $('.js-foldout-toggle', $container).click(function(e) {
        e.stopPropagation();
        $('.js-foldout').toggleClass('is-active');
        $('body, html').toggleClass('is-active is-compare');
    });

    $('.js-foldout', $container).click(function(e) {
        e.stopPropagation();
    });

    const loadUrl = $('[data-load-foldout]', $container).first().attr('data-load-foldout');
    if (loadUrl) {
        window.app.loadFoldout(loadUrl);
    }
    // Ensure we're never loading it again
    $('[data-load-foldout]', $container).removeAttr('data-load-foldout');

    if ($container.is('body')) {
        $('body, html').click(function() {
            $(this).removeClass('is-active is-compare')
            $('.js-foldout').removeClass('is-active');
        });
    }
}
